import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { IntegrationVendor } from '@magnetar/data-access'

interface CreateIntegrationVendor {
  vendor_name: string
  referer_urls: string[]
  permission_scopes: string[]
  is_active: boolean
}

interface UpdateIntegrationVendor {
  vendor_name: string
  referer_urls: string[]
  permission_scopes: string[]
  is_active: boolean
}

export const integrationVendorService = {
  createVendor: async (data: CreateIntegrationVendor, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: IntegrationVendor }>(
        '/api/integration-vendors',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateVendor: async (vendorId: number, data: UpdateIntegrationVendor, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: IntegrationVendor }>(
        `/api/integration-vendors/${vendorId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deactivateVendor: async (vendorId: number, token: string) => {
    try {
      const response = await apiClient.patch<{ success: boolean; data: IntegrationVendor }>(
        `/api/integration-vendors/${vendorId}/deactivate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  getVendorById: async (vendorId: number, token: string) => {
    try {
      const response = await apiClient.get<{ success: boolean; data: IntegrationVendor }>(
        `/api/integration-vendors/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },
}
